module.exports = __webpack_public_path__ + "img/41_46.882e6148.png";